import * as t from 'io-ts'
import fetchApi from 'ui-io/fetch-api'

export type ResourceType =
  | 'AdminTicket'
  | 'AdminProject'
  | 'AdminUser'
  | 'AdminTeam'
  | 'TODO'
export type CreateAssetQuery = {
  files: File[]
  content_type?: string
  resource_id?: string
  asset_id?: string
  resource_type?: ResourceType
  asset_type?: string
  expiry?: number
  tags?: string[]
	creation_user?: string
}
const formDataKeys = [
  'files',
  'content_type',
  'asset_id',
  'resource_type',
  'resource_id',
  'expiry',
  'asset_type',
  'tags',
	'creation_user'
] as const
type FormDataKey = typeof formDataKeys[number]
const isFormDataKey = (key: unknown): key is FormDataKey =>
  (formDataKeys as ReadonlyArray<unknown>).includes(key)

const TaskRejectReasonsFieldIO = t.type({
  name: t.string,
  options: t.array(t.string),
})

export type TaskRejectReasonsFieldT = t.TypeOf<typeof TaskRejectReasonsFieldIO>

const TaskRejectReasonsConfigIO = t.type({
  config: t.array(TaskRejectReasonsFieldIO),
})

const TaskEscalateReasonsConfigIO = t.type({
  config: t.array(t.string),
})


export const AssetsSettingsIO = t.type({
  settings: t.type({
    id: t.string,
    name: t.string,
    namespace: t.string,
    keys: t.partial({
      'task-reject-reasons-config': TaskRejectReasonsConfigIO,
      'task-escalate-reasons-config': TaskEscalateReasonsConfigIO,
      'task-de-escalate-reasons-config': TaskEscalateReasonsConfigIO,
      'task-block-reasons-config': TaskEscalateReasonsConfigIO,
    }),
  }),
})

export type AssetsSettings = t.TypeOf<typeof AssetsSettingsIO>

export const postAssetMutation = (createAssetQuery: CreateAssetQuery) => {
  // const { formData } = createAssetQuery
  const formData = new FormData()
  // const formdata = new FormData();
  // formdata.append("file", file, "sesame-seed.jpg");

  Object.keys(createAssetQuery)
    .filter(isFormDataKey)
    .forEach((key) => {
      const value = createAssetQuery[key as FormDataKey]

      if (value === undefined) return


       if (key === 'files' && Array.isArray(value)) {
        value.forEach((file) => {
          if (file instanceof File) {
            formData.append('files', file, file.name);
          } else {
            console.warn('Skipping invalid file:', file);
          }
        });
      } 
      else if (Array.isArray(value)) {
        value.forEach((v) => formData.append(key, v.toString()));
      } 
      else {
        formData.append(key, String(value));
      }
    })

  return fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/upload/assets/multiple`,
    headers: {
      Accept: '*/*',
    },
    body: formData,
    codec: t.array(
      t.type({
        asset_id: t.string,
        name: t.string,
        fileUrl: t.string,
        app_id: t.string,
        content_type: t.string,
        creation_time: t.number,
        creation_user: t.string,
        filename: t.string,
        filesize: t.number,
        resource_id: t.string,
        resource_type: t.string
      })
    ),
    ignoreDefaultHeaders: true,
  })
}
